import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import Cookies from 'js-cookie';

import Header, { NavLink, NavLinks, PrimaryLink, LogoLink, NavToggle, DesktopNavLinks } from "../headers/light.js";
import ResponsiveVideoEmbed from "../../helpers/ResponsiveVideoEmbed.js";

const StyledHeader = styled(Header)`
  ${tw`pt-8 max-w-none`}
  ${DesktopNavLinks} ${NavLink}, ${LogoLink} {
    ${tw`text-gray-100 hover:border-gray-300 hover:text-gray-300`}
  }
  ${NavToggle}.closed {
    ${tw`text-gray-100 hover:text-pbsGreen-500`}
  }
`;
const Container = styled.div`
  ${tw`relative -mx-8 -mt-8 bg-center bg-cover`}
  background-image: url("https://dillanoblake.sirv.com/Images/generatedImagechatgpt3.png");
`;

const OpacityOverlay = tw.div`z-10 absolute inset-0 bg-gray-900 opacity-25`;

const HeroContainer = tw.div`z-20 relative px-4 sm:px-8 max-w-screen-xl mx-auto`;
const LeftColumn = tw.div`flex flex-col items-center lg:block mt-[7rem] lg:mt-[9rem]`;
const TwoColumn = tw.div`pt-20 pb-12 px-4 flex justify-between items-start flex-col lg:flex-row`;
const RightColumn = tw.div`w-full sm:w-5/6 lg:w-1/2 mt-16 lg:mt-0 lg:pl-8`;

const Heading = styled.h1`
  ${tw`text-3xl text-center lg:text-left sm:text-4xl lg:text-5xl xl:text-6xl font-black text-gray-100 leading-none`}
  span {
    ${tw`inline-block mt-2`}
  }
`;

const SlantedBackground = styled.span`
  ${tw`relative text-pbsOrange-500 px-4 -mx-4 py-2 whitespace-nowrap font-semibold`}
  &::before {
    content: "";
    ${tw`absolute inset-0 bg-yellow-100 transform -skew-x-12 -z-10 rounded-md`}
  }
`;

const Notification = tw.span`inline-block my-4 pl-3 py-1 text-gray-100 border-l-4 border-blue-500 font-medium text-sm`;

const PrimaryAction = tw.button`
  px-8 py-3 mt-6 sm:mt-8 sm:px-8 sm:py-4 
  bg-gray-100 text-pbsGreen-500 font-bold rounded shadow 
  transition duration-300 hocus:bg-pbsGreen-500 hocus:text-gray-100 focus:shadow-outline
`;

const StyledResponsiveVideoEmbed = styled(ResponsiveVideoEmbed)`
  padding-bottom: 56.25% !important;
  padding-top: 0px !important;
  ${tw`rounded`}
  iframe {
    ${tw`rounded bg-black shadow-xl`}
  }
`;

export default () => {
  const navLinks = [
    <NavLinks key={1}>
          <NavLink href="/about">About</NavLink>
          <NavLink href="/contact">Contact Us</NavLink>
          <NavLink href="/info-corner">Info Corner</NavLink>
          <NavLink href="/services">Services</NavLink>
          <NavLink href="/jobs">Career</NavLink>
          {/* <NavLink href="/faq">FAQ</NavLink> */}
        </NavLinks>,
        <NavLinks key={2}>
          { !Cookies.get('id') ? (
            <PrimaryLink href="/login">Login</PrimaryLink>
          ) : (
            <PrimaryLink onClick={() => { Cookies.remove('id'); window.location.reload() }} >Sign Out</PrimaryLink>
          )}
        </NavLinks>
  ];

  return (
    <Container>
      <OpacityOverlay />
      <HeroContainer>
        <StyledHeader links={navLinks} />
        <TwoColumn>
          <LeftColumn>
            {/* <Notification>We have now launched operations in Europe.</Notification> */}
            <Heading>
              <span>Hire the best</span>
              <br />
              <SlantedBackground>HR Services Team.</SlantedBackground>
            </Heading>
            <PrimaryAction onClick={() => {window.location.href='/contact';}}>Contact Us</PrimaryAction>
          </LeftColumn>
          <RightColumn>
            {/* <StyledResponsiveVideoEmbed
              url="//player.vimeo.com/video/374265101?title=0&portrait=0&byline=0&autoplay=0&responsive=1"
              background="transparent"
            /> */}
          </RightColumn>
        </TwoColumn>
      </HeroContainer>
    </Container>
  );
};
